import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../explorer/hooks/useTranslation';

type AddBasketItemsWarningProps = { 
    apiResult: any
};
const AddBasketItemsWarning: React.FC<AddBasketItemsWarningProps> = (props: AddBasketItemsWarningProps) => {
    const { apiResult } = props;
    const { t } = useTranslation();
    return (
        <>
          <Box>{t("common.basket.itemsAddedSelectedBasket")}</Box>
          {apiResult?.notActiveParts?.length > 0 && (
            <>
              <Box>{t("common.basket.warning.notActiveParts")}:</Box>
              <ul>
                {apiResult?.notActiveParts?.map((part: any) => (
                  <li>{part.code}</li>
                ))}
              </ul>
            </>
          )}
          {apiResult?.replacedParts?.length > 0 && (
            <>
              <Box>{t("common.basket.warning.replacedParts")}:</Box>
              <ul>
                {apiResult?.replacedParts?.map((part: any) => (
                  <li>
                    {part.replacedCode} {"=>"} {part.code}
                  </li>
                ))}
              </ul>
            </>
          )}
        </>
      );
};

export default AddBasketItemsWarning;